import React, { useState } from 'react';
import { FormModal, btnPrimary, btnGhost } from '../shared/FormKit';
import { recordNotice } from './constants';

// Last stop before filing a Signed FS or QC35 submission. Those two flows
// carry no approval step: pressing Submit approves the request, creates the
// formal record and stamps the engagement in one go, and an approved request
// can no longer be modified or deleted — the only way to correct it is an
// amendment. So the page says that in words first.
//
//   title        — dialog title, e.g. 'Submit Signed Financial Statements'
//   lines        — the consequences, one <p> each
//   confirmLabel — the button that goes ahead
//   onConfirm    — async () => void; errors surface inline, the dialog stays
//                  open so the submission can be retried or abandoned
const SubmitConfirmModal = ({ title, lines, confirmLabel = 'Submit', onConfirm, onClose }) => {
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    setBusy(true);
    setError(null);
    try {
      await onConfirm();
    } catch (e) {
      setError(e.message);
      setBusy(false);
    }
  };

  return (
    <FormModal
      title={title}
      size="md"
      onClose={busy ? null : onClose}
      footer={(
        <>
          <button type="button" onClick={onClose} disabled={busy} className={btnGhost}>Cancel</button>
          <button type="button" onClick={submit} disabled={busy} className={btnPrimary}>
            {busy ? 'Submitting…' : confirmLabel}
          </button>
        </>
      )}
    >
      <div className={recordNotice}>
        {lines.map((line, i) => (
          <p key={i} className={i > 0 ? 'mt-2' : undefined}>{line}</p>
        ))}
      </div>
      {error && (
        <div className="p-3 bg-red-50 border border-red-200 rounded-lg text-red-700 text-sm">{error}</div>
      )}
    </FormModal>
  );
};

export default SubmitConfirmModal;
